import React from 'react';
import { Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import UnifiedDocumentUploader from '../Common/FileUploader';

const UploadDialog = ({ open, onClose, onComplete, requireAuth = false }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  // 处理文件上传完成
  const handleComplete = (files, language, certification_type = 'none', is_urgent = false) => {
    onComplete(files, language, certification_type, is_urgent);
  };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        elevation: 3,
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          height: '80vh',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }
      }}
    >
      <DialogContent 
        sx={{ 
          p: 0, 
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }}
      >
        <UnifiedDocumentUploader 
          onComplete={handleComplete} 
          onClose={onClose}
          isDialog={true}
          requireAuth={requireAuth}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadDialog;